import Link from 'next/link';
import CalendarIcon from '@/assets/icon/calendar.svg';
import { SupportedLanguages } from '@/types/globals';

interface CalendarViewToggleProps {
  locale: SupportedLanguages;
  basePath: string;
  className?: string;
}

const text = {
  en: {
    calendarView: 'Calendar View',
    listView: 'List View',
    viewEventsInCalendar: 'View events in calendar format',
  },
  fr: {
    calendarView: 'Vue Calendrier',
    listView: 'Vue Liste',
    viewEventsInCalendar: 'Voir les événements au format calendrier',
  },
};

export function CalendarViewToggle({
  locale,
  basePath,
}: CalendarViewToggleProps) {
  const translatedText = text[locale];
  const calendarPath = `/${basePath}/calendar`;

  return (
    <Link
      href={calendarPath}
      className={`inline-flex items-center gap-2 rounded border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 hover:text-gray-900`}
      title={translatedText.viewEventsInCalendar}
    >
      <CalendarIcon className="h-4 w-4" />
      {translatedText.calendarView}
    </Link>
  );
}
